export enum PersonTableColumns {
  Deceased = "deceased",
  Dob = "dob",
  ExternalId = "externalId",
  Gender = "gender",
  LanguageLocal = "languageLocal",
  NameAbbreviated = "nameAbbreviated",
  NameFamilyLatin = "nameFamilyLatin",
  NameFamilyLocal = "nameFamilyLocal",
  NameFullLatin = "nameFullLatin",
  NameFullLocal = "nameFullLocal",
  NameGivenLatin = "nameGivenLatin",
  NameGivenLocal = "nameGivenLocal",
  Nationality = "nationality",
  PersonId = "personId",
  Status = "status",
  KnownAs = "knownAs",
  Height = "height",
  Weight = "weight",
  HeightImperial = "heightImperial",
  WeightImperial = "weightImperial",
  Representation = "representation",
  JuniorAssociationLeague = "juniorAssociationLeague",
  School = "school",
  SchoolClass = "schoolClass",
  HomeTown = "homeTown",
  College = "college",
  CollegeClass = "collegeClass",
  Image = "image",
}
